import React, { useState , useEffect } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import MenuItem from "@material-ui/core/MenuItem";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons components
import Email from "@material-ui/icons/Email";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import Lock from "@material-ui/icons/Lock";
import School from "@material-ui/icons/School";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { Typography } from "@material-ui/core";
// core components
//import AuthHeader from "components/Headers/AuthHeader.js";
//import componentStyles from "assets/theme/views/auth/register.js";
import componentStylesButtons from "assets/theme/components/button.js";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    // Add animation styles
    animation: `$sideUp 0.5s ease-out`,
    transform: "translateY(100%)",
    opacity: 0,
    animationFillMode: "forwards",
  },
  "@keyframes sideUp": {
    "0%": {
      transform: "translateY(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 1,
    },
  },
  cardHeader: {
    textAlign: "center",
  },
  cardContent: {
    textAlign: "center",
  },
  buttonContainedInfo: {
    backgroundColor: theme.palette.info.main,
  },
}));

const useStylesButtons = makeStyles(componentStylesButtons);

function Register() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const theme = useTheme();
  const history = useHistory();
  const [privilege,setprivilege]=useState("")
  const [invalidLogin, setInvalidLogin] = useState(0);
  const [alertText, setalertText] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [form, setform] = useState({
    username: "",
    password: "",
    confirmpassword: "",
    email: "",
    firstname: "",
    lastname: "",
    role: "",
  });

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  //text fields changes
  const handleChange = (e) => {
    setalertText("");
    setform((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const RegisterCLick = () => {
    if (
      [
        "confirmpassword",
        "email",
        "password",
        "confirmpassword",
        "firstname",
        "lastname",
        "role",
      ].some((field) => form[field] === "")
    ) {
      setalertText("please fill all the fields");
      return;
    }
    if (form.confirmpassword !== form.password) {
      setalertText("password do not match");
      return;
    }
    if(form.role === "Role"){
      setalertText("Select correct role");
      return;
    }
    var token = localStorage.getItem("token");

    const fetchRegister = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/Create-User", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: form.username,
            password: form.password,
            firstname: form.firstname,
            lastname: form.lastname,
            email: form.email,
            role: form.role,
            token,
          }),
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();

        if (data.valid === false) {
          setalertText(data.message);
        } else if (data.valid === true) {
          setalertText(data.message);

          if (data.message === "User created successfully") {
            form.password = "";
            form.username = "";
            form.firstname = "";
            form.email = "";
            form.lastname = "";
          }
        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchRegister();
  };


  useEffect(() => {
    var token = localStorage.getItem("token")

    const fetchPrivilege = async (token) => {
      try {
        const response = await fetch('https://server.thelanofficial.com/privilege', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
        });
    
        const data = await response.json();
    
        if (data.valid) {
         
          // You can now use data.privilege for any conditional rendering or logic
        
          setprivilege(data.privilege)
        } else {
          console.log('Invalid token');
        }
      } catch (error) {
        console.error('Error fetching privilege:', error);
      }
    };

    fetchPrivilege(token);

    const fetchData = async () => {
      try {
        const res = await fetch('https://server.thelanofficial.com/validate-token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ token })
        });

        if (!res.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await res.json();
        if(data.valid === false){
          history.push("/auth/login")
        }
        
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Box component={Grid} container justifyContent="center">
        <Grid item xs={12} lg={6} md={8}>
          <Card classes={{ root: classes.cardRoot }}>
            <CardHeader
              className={classes.cardHeader}
              title={
                <Box
                  fontSize="200%"
                  fontWeight="800"
                  component="large"
                  color={theme.palette.gray[600]}
                >
                  REGISTER USER
                </Box>
              }
              titleTypographyProps={{
                component: Box,
                textAlign: "center",
                marginBottom: "1rem!important",
                marginTop: ".5rem!important",
                fontSize: "1rem!important",
              }}
            ></CardHeader>
            <CardContent classes={{ root: classes.cardContent }}>
              <Box
                color={theme.palette.gray[600]}
                textAlign="center"
                marginBottom="1.5rem"
                marginTop=".5rem"
                fontSize="1rem"
              >
                <Box fontSize="80%" fontWeight="400" component="small">
                  Register by giving the following information
                </Box>
              </Box>

              <Box style={{ display: "flex", direction: "col", gap: "5px" }}>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    name="firstname"
                    value={form.firstname}
                    onChange={handleChange}
                    type="text"
                    placeholder="First Name"
                    startAdornment={
                      <InputAdornment position="start">
                        <School />
                      </InputAdornment>
                    }
                  />
                </FormControl>

                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type="text"
                    name="lastname"
                    value={form.lastname}
                    onChange={handleChange}
                    placeholder="Last Name"
                    startAdornment={
                      <InputAdornment position="start">
                        <School />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>

              <Box style={{ display: "flex", direction: "col", gap: "5px" }}>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type="text"
                    name="username"
                    value={form.username}
                    onChange={handleChange}
                    placeholder="Username"
                    startAdornment={
                      <InputAdornment position="start">
                        <School />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Email"
                    startAdornment={
                      <InputAdornment position="start">
                        <Email />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>

              <Box style={{ display: "flex", direction: "col", gap: "5px" }}>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleTogglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>

                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    autoComplete="off"
                    name="confirmpassword"
                    value={form.confirmpassword}
                    onChange={handleChange}
                    type={showPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleTogglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>

              <FormControl variant="outlined" fullWidth>
                <Select
                  placeholder="ROLE"
                  name="role"
                  defaultValue={"Role"}
                  onChange={handleChange}
                  IconComponent={KeyboardArrowDown}
                >
                  <MenuItem value={"Role"}>Role</MenuItem>
                  <MenuItem value={"Teacher"}>Teacher</MenuItem>
                  <MenuItem value={"Student"}>Student</MenuItem>
                  {(privilege === 'super admin') && (
                  <MenuItem value={"Admin"}>Admin</MenuItem>
                )}
                </Select>
              </FormControl>

              <Box
                fontStyle="italic"
                fontSize="1rem"
                color={theme.palette.gray[600]}
                marginBottom=".5rem"
              >
                <Box component="small" fontSize="80%">
                  <Box
                    component="span"
                    fontWeight="700"
                    color={theme.palette.success.main}
                  ></Box>
                </Box>
              </Box>

              <Typography
                style={{
                  color:
                    alertText === "User created successfully" ? "green" : "red",
                  fontSize: "10px",
                }}
              >
                {alertText}
              </Typography>

              <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">
                <Button
                  onClick={RegisterCLick}
                  variant="contained"
                  classes={{ root: classes.buttonContainedInfo }}
                >
                  Create account
                </Button>
              </Box>
            </CardContent>
          </Card>
          <Grid container component={Box} marginTop="1rem">
            <Grid item xs={6} component={Box} textAlign="left"></Grid>
            <Grid item xs={6} component={Box} textAlign="right"></Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default Register;
